export default __webpack_public_path__ + "static/media/wy_pszczolki.3331a822.svg";